/**
 * Do not edit directly, this file was auto-generated.
 */

export const ColorsBlackPrimary = "#111111ff";
export const ColorsBlackLight = "#363636ff";
export const ColorsBlackLightest = "#4a4a4aff";
export const ColorsBlackDark = "#000000ff";
export const ColorsWhite = "#ffffffff";
export const ColorsCoral50 = "#ffd7cbff";
export const ColorsCoral100 = "#eb736bff";
export const ColorsCoral200 = "#ed6153ff";
export const ColorsCoral300 = "#ff5b5dff";
export const ColorsCoral400 = "#c75552ff";
export const ColorsCoral500 = "#94403dff";
export const ColorsCoralPrimary = "#ff5b5dff";
export const ColorsCoralLight = "#ffd7cbff";
export const ColorsCoralMedium = "#ed6153ff";
export const ColorsCoralDark = "#c75552ff";
export const ColorsCoralDarkest = "#94403dff";
export const ColorsTeal50 = "#e6fffaff";
export const ColorsTeal100 = "#d7ebe8ff";
export const ColorsTeal200 = "#c6f7eeff";
export const ColorsTeal300 = "#b4e0d8ff";
export const ColorsTeal500 = "#68ada1ff";
export const ColorsTeal700 = "#497a71ff";
export const ColorsTealLightest = "#e6fffaff";
export const ColorsTealLight = "#68ada1ff";
export const ColorsTealPrimary = "#497a71ff";
export const ColorsAquamarinePrimary = "#b4e0d8ff";
export const ColorsAquamarineLight = "#c6f7eeff";
export const ColorsGray100 = "#f3f3f3ff";
export const ColorsGray200 = "#dcdedfff";
export const ColorsGray300 = "#c7c8caff";
export const ColorsGray400 = "#b2b3b6ff";
export const ColorsGray500 = "#9e9fa2ff";
export const ColorsGray600 = "#8b8c8fff";
export const ColorsGray700 = "#77787cff";
export const ColorsGray800 = "#636566ff";
export const ColorsGray900 = "#4c4e4fff";
export const ColorsGray999 = "#313030ff";
export const ColorsGrayLight = "#e8e8e8ff";
export const ColorsGrayNeutral = "#c9c9c9ff";
export const ColorsGrayMedium = "#d0d0d0ff";
export const ColorsGrayDark = "#9b9b9bff";
export const ColorsGrayDarkest = "#5c5c5cff";
export const ColorsGray001 = "#fafafaff";
export const ColorsGreenBluePrimary = "#68ada1ff";
export const ColorsGreenBlueLight = "#c6f7eeff";
export const ColorsGreenBlueDark = "#497a71ff";
export const ColorsGreen50 = "#edffc3ff";
export const ColorsGreen300 = "#4bbb88ff";
export const ColorsGreen400 = "#6dba53ff";
export const ColorsGreen500 = "#18b835ff";
export const ColorsGreenPrimary = "#18b835ff";
export const ColorsGreenLight = "#edffc3ff";
export const ColorsLegalBluePrimary = "#3d67ffff";
export const ColorsLegalBlueLight = "#8ea7ffff";
export const ColorsLegalBlueDark = "#3858cbff";
export const ColorsBlue50 = "#d8e6feff";
export const ColorsBlue200 = "#8ea7ffff";
export const ColorsBlue300 = "#63afe3ff";
export const ColorsBlue400 = "#3d67ffff";
export const ColorsBlue500 = "#3858cbff";
export const ColorsBlue600 = "#0b5cabff";
export const ColorsBlue700 = "#214978ff";
export const ColorsBluePrimary = "#0b5cabff";
export const ColorsBlueLight = "#d8e6feff";
export const ColorsPink50 = "#fdf1ebff";
export const ColorsPink100 = "#facccaff";
export const ColorsPinkPrimary = "#facccaff";
export const ColorsPinkLight = "#fdf1ebff";
export const ColorsNeonRosePrimary = "#ff2e63ff";
export const ColorsAccentGreenPrimary = "#6dba53ff";
export const ColorsYellowGreenPrimary = "#dfff00ff";
export const ColorsMintPrimary = "#00e298ff";
export const ColorsOrangePrimary = "#ff8022ff";
export const ColorsRed50 = "#fdf1ebff";
export const ColorsRed300 = "#e16053ff";
export const ColorsRed500 = "#ff3b30ff";
export const ColorsRedPrimary = "#ff3b30ff";
export const ColorsRedLight = "#fdf1ebff";
export const ColorsYellow50 = "#ffffddff";
export const ColorsYellow100 = "#f9e3b6ff";
export const ColorsYellow300 = "#f7b343ff";
export const ColorsYellow400 = "#f3a551ff";
export const ColorsYellowPrimary = "#f7b343ff";
export const ColorsYellowLight = "#f9e3b6ff";
export const ColorsFuchsiaPrimary = "#ea0ce3ff";
export const ColorsPurple50 = "#f5e7ffff";
export const ColorsPurple400 = "#ea0ce3ff";
export const ColorsPurple500 = "#a229ffff";
export const ColorsPurple600 = "#b310ffff";
export const ColorsPurplePrimary = "#a229ffff";
export const ColorsPurpleLight = "#f5e7ffff";
export const ColorsNeutral50 = "#f3f3f3ff";
export const ColorsNeutral100 = "#e8e8e8ff";
export const ColorsNeutral200 = "#d0d0d0ff";
export const ColorsNeutral300 = "#c9c9c9ff";
export const ColorsNeutral400 = "#9b9b9bff";
export const ColorsNeutral500 = "#8b8b8bff";
export const ColorsNeutral600 = "#5c5c5cff";
export const ColorsNeutral700 = "#4a4a4aff";
export const ColorsNeutral800 = "#363636ff";
export const ColorsNeutral900 = "#111111ff";
